import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";

import Badge from "features/components/Badge";
import IconButton from "features/components/IconButton";

interface FilterIconButtonProps {
  activeFilterCount: number;
  onClick?: () => void;
  disabled?: boolean;
  dataTestId?: string;
}

const TableFilterButton = ({
  activeFilterCount,
  onClick,
  disabled,
  dataTestId,
}: FilterIconButtonProps) => (
  <Badge badgeContent={activeFilterCount}>
    <IconButton
      onClick={onClick}
      color="secondary"
      size="small"
      data-testid={dataTestId}
      disabled={disabled}
    >
      <FilterAltOutlinedIcon fontSize="small" />
    </IconButton>
  </Badge>
);

export default TableFilterButton;
